import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from '../constants';
import { Widget } from './Widget';

export const FileEmbeds = () => {
  const {
    widgetId,
    customCSS,
    customJS,
    editMode,
    width,
    renderThumbnailMode
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <EmbedRoot customCSSClassName={customCSSPrefixClassName} width={width}>
      <CustomCSS
        prefixClassName={customCSSPrefixClassName}
        customCSS={customCSS}
      />

      <Widget />
    </EmbedRoot>
  );
};
